import React from "react";
import { GlobalStyles } from "@mui/material";
import { cssVariables, schemes } from "./tokens";

const dark = schemes.dark;
const D = 'html[data-theme="dark"]';

// The colour variables for both schemes, plus the few global surfaces that
// sit outside the component tree (page ground, toasts, scrollbars).
const styles = `
${cssVariables()}
${D}, ${D} body { background-color: ${dark["a4-bg"]}; color: ${dark["a4-ink"]}; }
${D} *::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.18); }
${D} * { scrollbar-color: rgba(255,255,255,0.18) transparent; }
${D} .Toastify__toast-theme--light { background: ${dark["a4-card"]}; color: ${dark["a4-ink"]}; box-shadow: 0 0 0 1px ${dark["a4-line-strong"]}, 0 16px 40px -12px rgba(0,0,0,.6); }
${D} .Toastify__close-button--light { color: ${dark["a4-ink2"]}; opacity: .7; }
${D} .Toastify__progress-bar--bg { opacity: .2; }
html.theme-switching, html.theme-switching *, html.theme-switching *::before, html.theme-switching *::after {
  transition: background-color .28s ease, color .28s ease, border-color .28s ease, box-shadow .28s ease, fill .28s ease, stroke .28s ease !important;
  transition-delay: 0s !important;
}
@media (prefers-reduced-motion: reduce) {
  html.theme-switching, html.theme-switching *, html.theme-switching *::before, html.theme-switching *::after { transition: none !important; }
}
`;

export default function ColorSchemeStyles() {
  return <GlobalStyles styles={styles} />;
}
